import React from 'react'
import { MerchantLocationsLoader, LoaderSwitcher } from 'router/Loaders'
import Integrations from 'components/Integrations'

export const IntegrationsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <Integrations />
        </LoaderSwitcher>
      )}
    </MerchantLocationsLoader>
  )
}
